export const ERROR_REPORTING_PACKAGE_NAME = 'jiraAdminPagesIssueTypesAddModal';

export const ISSUE_TYPE_TYPES: {
	STANDARD: 'standard';
	SUBTASK: 'subtask';
} = {
	STANDARD: 'standard',
	SUBTASK: 'subtask',
};

export const ERROR_TYPES = {
	ALREADY_EXISTS: 'ALREADY_EXISTS',
	INVALID: 'INVALID',
	TOO_LONG: 'TOO_LONG',
	TOO_SHORT: 'TOO_SHORT',
} as const;
